import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'Total TVL in Sonic Vault',
    tvlLabel: '~ {value} LBTC',
  },
};
